"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Purchase = void 0;
var _react = require("react");
var _Purchase = require("./Purchase.styles");
var _fallback_image = _interopRequireDefault(require("../../resources/fallback_image.png"));
var _Button = require("../../../../UI/Button");
var _Img = require("../../../../UI/Img");
var _Title = require("../../../../UI/Title");
var _CetComponentsProvider = require("../../../../providers/CetComponentsProvider");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const Purchase = props => {
  const {
    imageAlt = '',
    title,
    image,
    buttonLabel,
    buttonUrl
  } = props;
  const styles = (0, _Purchase.useStyles)();
  const {
    themeColors
  } = (0, _react.useContext)(_CetComponentsProvider.CetComponentsContext);
  const handleClick = () => {
    window.open(buttonUrl);
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("section", {
    className: styles['cc-Login__purchase-section'],
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Title.Title, {
      level: 3,
      color: themeColors?.primary.main,
      children: title
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: styles['cc-Login__purchase-img'],
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Img.Img, {
        src: image,
        fallback: _fallback_image.default,
        alt: imageAlt,
        width: "100%",
        height: "100%",
        borderRadius: {
          borderRadius: 22
        }
      })
    }), buttonUrl && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.Button, {
      id: "ccPurchaseButton",
      view: "contained",
      color: "primary",
      size: "large",
      onClick: handleClick,
      children: buttonLabel
    })]
  });
};
exports.Purchase = Purchase;